






















import { defineComponent } from '@vue/composition-api';
import { mapState, mapGetters } from 'vuex';
import { GetHeatingControlDevices_spots_items } from '../graphql/__generated__/GetHeatingControlDevices';

export default defineComponent<any, Record<string, unknown>, any, any, any>({
  props: {
    searchTxt: {
      type: String,
      default: null,
    },
    searchFilter: {
      type: String,
      default: null,
    },
    heatingSystems: {
      type: Array as () => GetHeatingControlDevices_spots_items[],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      searchInput: '',
      filteredHeatingSystemsData: [],
    };
  },
  computed: {
    ...mapState({
      activeHeatingSystemId: (state: any) => state.ModbusEditRegistersModule.activeHeatingSystemId,
      activeHeatingSystems: (state: any) => state.ModbusEditRegistersModule.activeHeatingSystems,
    }),
    ...mapGetters(['activeControlModelName']),
    shouldShowHeatingSystems() {
      return this.filteredHeatingSystemsData.length > 0;
    },
  },
  watch: {
    searchTxt() {
      this.heatingSystemList(); // Recalculate on search text change
    },
    searchFilter() {
      this.heatingSystemList();
    },
    heatingSystems(heatingSystemControlSpots: GetHeatingControlDevices_spots_items[]) {
      this.heatingSystemList(); // Update filteredHeatingSystemsData

      // Auto-select the first heating system if none is selected
      if (
        heatingSystemControlSpots.length > 0 &&
        !this.activeHeatingSystemId &&
        this.filteredHeatingSystemsData.length > 0
      ) {
        const firstId = this.filteredHeatingSystemsData[0].id;
        this.$store.dispatch('setActiveHeatingSystem', firstId);
      }
    },
  },
  methods: {
    setActiveHeatingSystem(id: string) {
      this.$store.dispatch('setActiveHeatingSystem', id);
    },
    heatingSystemList(): void {
      const search = this.searchTxt?.toLowerCase().trim() === '' ? null : this.searchTxt?.toLowerCase().trim();

      this.filteredHeatingSystemsData = this.activeHeatingSystems
        .filter((site: { siteId: string; name: string }) => {
          const nameMatch = search ? site.name?.toLowerCase().includes(search) : false;

          if (search) {
            return nameMatch;
          } else {
            return true;
          }
        })
        .map((site: { siteId: string; name: string }) => ({
          id: site.siteId,
          name: site.name,
        }))
        .sort((a: { id: string; name: string }, b: { id: string; name: string }) => a.name.localeCompare(b.name));
    },
  },
});
